import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AppContext } from '../context/AppContext';
import './PaymentOptionsModal.css';
import '../css/mainhome.css';

import googlePayIcon from '../assets/icons/google-pay-or-tez-logo-svgrepo-com.svg';
import phonePeIcon from '../assets/icons/phonepe-icon.svg';
import paytmIcon from '../assets/icons/paytm_icon-icons.com_62778.svg';

// ---- Helpers ----
const buildUpiQS = ({ pa, pn, am, tr, tn }) =>
  new URLSearchParams({
    pa: pa || '',
    pn: pn || '',
    am: (Number(am) || 0).toFixed(2),
    tr: tr || '',
    tn: tn || '',
    cu: 'INR',
  }).toString();

const PaymentOptionsModal = ({ amount, onClose }) => {
  const { user } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);

  const handlePayment = async (depositType) => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      const registerId = user?.registerId || localStorage.getItem('registerId');
      if (!token || !registerId) throw new Error('Authentication error. Please log in again.');

      // 1) Create payment session
      const { data } = await axios.post(
        'https://admin.thedpboss.com/api/v1/deposit-create-upi-fund-request',
        { registerId, depositType, amount: Number(amount), hashKey: 'chela' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            deviceId: 'qwert',
            deviceName: 'sm2233',
            accessStatus: '1',
          },
        }
      );

      if (!data?.status || !data?.info) {
        throw new Error(data?.msg || 'Failed to create payment request.');
      }

      const { upiID, paymentHash, remark, timestamp } = data.info;
      const merchantName = 'DPBOSS';

      // Persist for verify step (DO NOT clear now). Stamp createdAt.
      localStorage.setItem('pendingTransaction', JSON.stringify({
        registerId,
        depositType,
        amount: Number(amount),
        hashKey: 'chela',
        timestamp,
        paymentHash,
        remark,
        createdAt: Date.now()
      }));

      // 2) Open UPI
      const qs = buildUpiQS({
        pa: upiID,
        pn: merchantName,
        am: amount,
        tr: paymentHash,
        tn: String(remark ?? ''),
      });

      const upiUrl = `upi://pay?${qs}`;
      window.location.href = upiUrl;

      onClose();
    } catch (err) {
      console.error('Payment initiation failed:', err);
      alert(err?.message || 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="payment-modal-overlay"
      onClick={!isLoading ? onClose : undefined}
      role="dialog"
      aria-modal="true"
    >
      <div className="payment-modal-content" onClick={(e) => e.stopPropagation()}>
        <h4>Select Payment Method</h4>

        {isLoading ? (
          <div className="payment-loader">Loading...</div>
        ) : (
          <div className="payment-options">
            <button
              className="payment-option-btn"
              disabled={isLoading}
              onClick={() => handlePayment('googlePay')}
            >
              <img src={googlePayIcon} alt="Google Pay" />
              <span>Google Pay</span>
            </button>

            <button
              className="payment-option-btn"
              disabled={isLoading}
              onClick={() => handlePayment('phonePe')}
            >
              <img src={phonePeIcon} alt="PhonePe" />
              <span>PhonePe</span>
            </button>

            <button
              className="payment-option-btn"
              disabled={isLoading}
              onClick={() => handlePayment('paytm')}
            >
              <img src={paytmIcon} alt="Paytm" />
              <span>Paytm</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentOptionsModal;
